<template>
  <Reports />
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import Reports from '@/components/content/Reports.vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'ReportsView',
  components: { Reports },
  setup(props, context) {
    const i18n = useI18n()

    context.emit('pageName', i18n.t('aside.menu.pages.reports'))

    watch(() => i18n.locale.value, () => {
      context.emit('pageName', i18n.t('aside.menu.pages.reports'))
    })
  }
})
</script>